export default __webpack_public_path__ + "static/media/video-sol-centre-2.5b92117b.mp4";